<template>
  <div
    class="tab-pane fade show active"
    id="nav-meter_point_summary"
    role="tabpanel"
    aria-labelledby="nav-meter_point_summary-tab"
  >
    <div class="container-fluid" v-if="activeService">
      <div class="row">
        <div class="col-sm-12">
          <div class="row 1">
            <div class="col-md-6 mt-3">
              <div class="mps mt-3">
                <div class="mps_info">
                  <div class="p-1 bg-white" v-if="meterPoint">
                    <div class="d-inline-block left">
                      <p
                        v-if="activeServiceType === 'Gas'"
                        class="font-weight-bold"
                      >
                        MPRN:
                      </p>
                      <p v-else class="font-weight-bold">MPAN:</p>
                    </div>
                    <div class="d-inline-block right">
                      <a
                        v-if="activeServiceType === 'Gas'"
                        class="pointer"
                        v-clipboard:copy="meterPoint.Mprn"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >
                        <p>{{ meterPoint.Mprn }}</p>
                      </a>
                      <a
                        v-else
                        class="pointer"
                        v-clipboard:copy="meterPoint.Mpan"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >
                        <p>{{ meterPoint.Mpan }}</p>
                      </a>
                    </div>
                  </div>

                  <div
                    class="p-1 bg-white"
                    v-if="
                      meterPoint && activeServiceType === 'Electricity'
                    "
                  >
                    <div class="d-inline-block left">
                      <p class="font-weight-bold">Market Segment:</p>
                    </div>
                    <div class="d-inline-block right">
                      <p v-if="marketSegment === 'SmartIncludingTraditional'">Smart {{ measurementMethod === 'NonHalfHourly' ? '(Traditional)' : '' }}</p>
                      <p v-else-if="marketSegment === 'Advanced' || marketSegment === 'Unmetered'">{{marketSegment}}</p>
                      <p v-else>Unknown</p>
                    </div>
                  </div>

                  <div
                    class="p-1 bg-white"
                    v-if="
                      meterPoint &&
                      activeServiceType === 'Electricity' &&
                      maximumImportCapacity != null
                    "
                  >
                    <div class="d-inline-block left">
                      <p class="font-weight-bold">Max. Import Capacity:</p>
                    </div>
                    <div class="d-inline-block right">
                      <p>{{ maximumImportCapacity }} kVA</p>
                    </div>
                  </div>

                  <div
                    class="p-1 bg-white"
                    v-if="meterPoint && activeServiceType === 'Gas'"
                  >
                    <div class="d-inline-block left">
                      <p class="font-weight-bold">LDZ:</p>
                    </div>
                    <div class="d-inline-block right">
                      <p>{{ meterPoint.LocalDistributionZone }}</p>
                    </div>
                  </div>
                  <div
                    class="p-1 bg-white"
                    v-else-if="
                      meterPoint && activeServiceType === 'Electricity'
                    "
                  >
                    <div class="d-inline-block left">
                      <p class="font-weight-bold">GSP:</p>
                    </div>
                    <div class="d-inline-block right">
                      <p>{{ meterPoint.GridSupplyPoint }}</p>
                    </div>
                  </div>


                  <div class="p-1 bg-white" v-if="meters.length > 0">
                    <div class="d-inline-block left">
                      <p class="font-weight-bold">Serial Number:</p>
                    </div>
                    <div v-if="currentMeter" class="d-inline-block right">
                      <a
                        class="pointer"
                        v-clipboard:copy="currentMeter.Serial"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                      >
                        <p>{{ currentMeter.Serial }}</p>
                      </a>
                    </div>
                  </div>

                  <div class="p-1 bg-white" v-if="meters.length > 0">
                    <div class="d-inline-block left">
                      <p class="font-weight-bold">Meter Location:</p>
                    </div>
                    <div class="d-inline-block right">
                      <p v-if="currentConfig">{{ currentConfig.Location | splitString }}</p>
                    </div>
                  </div>

                  <div class="p-1 bg-white" v-if="activeService">
                    <div class="d-inline-block left align-top">
                      <p class="font-weight-bold">Site:</p>
                    </div>
                    <div class="d-inline-block right">
                      <i
                        class="float-right pointer fas fa-edit rel"
                        data-toggle="modal"
                        data-target=".updateSiteAddress"
                        @click="cloneSite()"
                      ></i>
                      <ul class="list-unstyled">
                        <li class="list-group-item"
                          v-for="(line, index) in activeService.Site.Address
                            .AddressLines"
                          :key="index"
                        >
                          <p>{{ line }}</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="p-1 bg-white d-flex align-items-start">
                    <div class="left">
                      <p class="font-weight-bold">Bill Service:</p>
                    </div>
                    <div class="right">
                      <div class="suspend-billing">
                        <div class="d-flex align-items-center">
                          <span v-if="tenancy" class="pointer" @click="promptDoNotBill(!tenancy.DoNotBill)">
                            {{ tenancy.DoNotBill ? 'Excluded' : 'Included' }}
                          </span>
                          <a
                            v-if="tenancy"
                            tabindex="0"
                            class="pointer bill-service-history ml-2"
                            @click="openHistory"
                            >History</a
                          >
                        </div>
                        <span v-if="tenancy" class="bill-service-toggle pointer" @click="promptDoNotBill(!tenancy.DoNotBill)">
                          <switches
                            :value="!tenancy.DoNotBill"
                            type-bold="true"
                            theme="bootstrap"
                            color="success"
                          ></switches>
                        </span>
                      </div>
                    </div>
                  </div>
                  <do-not-bill-reason-modal
                    @save="onReasonSave"
                    @cancel="onReasonCancel"
                  />
                  <do-not-bill-history-modal
                    :changes="historyChanges"
                    :loading="historyLoading"
                    :error="historyError"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6 my-3" v-if="activeService">
              <iframe
                :src="`https://www.google.com/maps/embed/v1/place?key=${googleApi}&q=${mapsQuery}`"
                class="pr-2"
              ></iframe>
            </div>
          </div>
          <hr class="mt-2" />
          <!-- ##################################################################################################################################### -->
          <div class="row 2">
            <div class="col-md-6">
              <div class="p-1 bg-transparent" v-if="registration">
                <div class="d-inline-block left">
                  <p class="font-weight-bold">Registered:</p>
                </div>
                <div class="d-inline-block right">
                  <p>{{ registration.EffectiveFrom | shortDate }}</p>
                </div>
              </div>
              <div class="p-1 bg-transparent" 
                v-if="registration 
                      && activeServiceType === 'Electricity'
                      && registration.MhhsMigrationDate
                      && registration.MhhsMigrationDate !== registration.EffectiveFrom"
              >
                <div class="d-inline-block left mt-2">
                  <p class="font-weight-bold">MHHS Effective Date:</p>
                </div>
                <div class="d-inline-block right">
                  <p>{{ registration.MhhsMigrationDate | shortDate }}</p>
                </div>
              </div>
              <div class="p-1 bg-white">
                <div class="d-inline-block left mt-2">
                  <p
                    v-if="activeServiceType === 'Gas'"
                    class="font-weight-bold"
                  >
                    Annual Quantity:
                  </p>
                  <p v-else class="font-weight-bold">EAC:</p>
                </div>
                <div
                  class="d-inline-block right"
                  v-if="activeServiceType === 'Gas'"
                >
                  <!-- <p v-if="meterPointElec && meterPointElec.Eacs.length > 0">{{ eacTotal }}</p> -->
                  <p
                    v-if="
                      meterPoint && meterPoint.AnnualisedQuantity.length > 0
                    "
                  >
                    {{ currentAQ }} kWh
                  </p>
                  <p v-else>Unknown</p>
                </div>
                <div
                  class="d-inline-block right"
                  v-if="activeServiceType === 'Electricity'"
                >
                  <p v-if="meterPoint && meterPoint.Eacs.length > 0">
                    {{ eacTotal }}
                  </p>
                  <p v-else>Unknown</p>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="p-1 bg-transparent" v-if="registration">
                <div class="d-inline-block left">
                  <p class="font-weight-bold">Acquisition:</p>
                </div>
                <div class="d-inline-block right">
                  <p
                    v-if="
                      tenancyAcquisitionType == 'Transferred' &&
                      transferredCustomer('from')
                    "
                    class="d-inline"
                  >
                    {{ tenancyAcquisitionType }} from
                    <router-link
                      :to="{
                        path:
                          '/dashboard/' +
                          transferredCustomer('from').CustomerReference,
                      }"
                      target="_blank"
                      class="underline"
                      >{{
                        transferredCustomer("from").CustomerReference
                      }}</router-link
                    >
                    ({{ tenancy.EffectiveFrom | shortDate }})
                  </p>
                  <p v-else class="d-inline">
                    {{ tenancyAcquisitionType }}
                  </p>
                  <!-- <a class="pointer underline d-inline m-20" data-toggle="modal" data-target=".undoTransfer">(Undo)</a> -->
                </div>
              </div>
              <div class="p-1 bg-transparent">
                <div class="d-inline-block left mt-2">
                  <p class="font-weight-bold">Release:</p>
                </div>
                <div class="d-inline-block right">
                  <p
                    v-if="
                      tenancyReleaseType == 'Transferred' &&
                      transferredCustomer('to')
                    "
                    class="d-inline"
                  >
                    {{ tenancyReleaseType | splitString }} to
                    <router-link
                      :to="{
                        path:
                          '/dashboard/' +
                          transferredCustomer('to').CustomerReference,
                      }"
                      target="_blank"
                      class="underline"
                      >{{
                        transferredCustomer("to").CustomerReference
                      }}</router-link
                    >
                    ({{ transferredCustomer("to").EffectiveFrom | shortDate }})
                  </p>
                  <p
                    v-else-if="
                      tenancyReleaseType === 'Lost' &&
                      tenancy && tenancy.EffectiveTo
                    "
                    class="d-inline"
                  >
                    {{ tenancyReleaseType | splitString }}
                    ({{ tenancy.EffectiveTo | shortDate }})
                  </p>
                  <p v-else class="d-inline">
                    {{ tenancyReleaseType | splitString }}
                  </p>
                </div>
              </div>
            </div>   
          </div>
          <hr class="mt-2" />
          <!-- ##################################################################################################################################### -->
          <div class="row pb-1">
            <div class="col-12 my-auto">
              <h5 class="d-inline">
                Recent
                <span
                  v-if="
                    activeServiceType === 'Gas' ||
                    !shouldShowAdvances
                  "
                  >Readings</span
                >
                <span v-else>Advances</span>
              </h5>
              <a
                class="btn btn-hc-nb"
                role="button"
                @click="showPanel"
                v-if="
                  activeServiceType === 'Gas' ||
                  !shouldShowAdvances
                "
              >
                <img
                  src="@/assets/img/add_icon_hcg.png"
                  class="pl-2 d-inline-block"
                  alt="Add Icon"
                />
              </a>
            </div>
          </div>
          <div class="row" v-if="readings.length > 0 || shouldShowAdvances">
            <div class="col">
              <gas-readings
                v-if="activeServiceType === 'Gas'"
                :showExcludedReadings="true"
                :showOnlyCustomer="true"
                :meterSerialFilter="'All'"
              />
              <electricity-readings-nhh
                v-if="
                  activeServiceType == 'Electricity' &&
                  measurementMethod == 'NonHalfHourly'
                "
                :showExcludedReadings="true"
                :showOnlyCustomer="true"
                :meterSerialFilter="'All'"
              />
              <electricity-readings-hh
                v-else-if="
                  activeServiceType == 'Electricity' &&
                  shouldShowAdvances
                "
              />
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-12">
              <div class="h-100">
                <div
                  class="d-flex h-100 justify-content-center align-items-center"
                >
                  <img
                    src="@/assets/img/tick_selector.png"
                    class="img-fluid d-inline-block"
                    alt="No charges have been applied to this account"
                  />
                  <p class="d-inline-block my-auto pl-2">
                    No
                    <span
                      v-if="
                        activeServiceType === 'Gas' ||
                        !shouldShowAdvances
                      "
                      >readings</span
                    >
                    <span v-else>advances</span> have been added to date.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment';
import _filters from '@/mixins/filters';

import ReadingsPanel from '@/components/panels/readings-panel-components/ReadingsPanel';

import gasReadings from './components/GasReadings';
import electricityReadingsNhh from './components/ElectricityReadingsNHH';
import electricityReadingsHh from './components/ElectricityReadingsHH';
import DoNotBillReasonModal from './components/DoNotBillReasonModal';
import DoNotBillHistoryModal from './components/DoNotBillHistoryModal';
import moment from 'moment';

export default {
  name: 'meterPointSummary',
  mixins: [_filters],
  components: {
    gasReadings,
    electricityReadingsNhh,
    electricityReadingsHh,
    DoNotBillReasonModal,
    DoNotBillHistoryModal,
  },
  data() {
    return {
      reasonModalId: 'donotbill-reason-modal',
      historyModalId: 'donotbill-history-modal',
      pendingDoNotBill: null,
      historyChanges: [],
      historyLoading: false,
      historyError: false,
    };
  },
  computed: {
    customer() {
      return this.$store.state.customers.customer;
    },
    activeService() {
      return this.$store.state.meters.activeService;
    },
    activeServiceType() {
      return this.$store.state.meters.activeService.Service.ServiceType;
    },
    meterPoint() {
      return this.$store.state.meters.activeService.MeterPoint;
    },
    meters() {
      return this.$store.state.meters.activeService.Meters;
    },
    readings() {
      return this.$store.state.meters.activeService.Readings;
    },
    registration() {
      return this.$store.state.meters.activeService.Registration;
    },
    tenancies() {
      if (this.activeService) return this.activeService.Tenancies;
    },
    eac() {
      return this.$_.sortBy(
        this.activeService.MeterPoint.Eacs,
        'EffectiveFrom'
      ).reverse()[0];
    },
    eacTotal() {
      if (this.activeService.Service.ServiceType !== 'Electricity') return null;
      else if (!this.eac) return 'Unknown';
      else {
        const eacs = this.eac.Tprs.map((tpr) => tpr.Value);
        const precision = eacs.reduce((pre, eac) => {
          const decimals = eac.toString().split('.')[1];
          const currPre = decimals ? decimals.length : 0;
          return Math.max(currPre, pre);
        }, 0);
        const factor = 10 ** precision;

        let eacTotal = 0;
        this.eac.Tprs.forEach((tpr) => {
          eacTotal += tpr.Value * factor;
        });

        return eacTotal / factor;
      }
    },
    measurementMethod() {
      return this.$_.sortBy(
        this.$store.state.meters.activeService.MeterPoint.MeterPointConfigs,
        'EffectiveFrom'
      ).reverse()[0].MeasurementMethod;
    },
    marketSegment() {
      return this.$_.sortBy(
        this.$store.state.meters.activeService.MeterPoint.MeterPointConfigs,
        'EffectiveFrom'
      ).reverse()[0].MarketSegment;
    },
    maximumImportCapacity() {
      return this.$store.state.meters.activeService.MeterPoint.ActiveMic;
    },
    currentConfig() {
      if (this.meters) {
        return this.meters
          .flatMap((m) => m.MeterConfigs)
          .reduce(
            (last, curr) =>
              last.EffectiveFrom > curr.EffectiveFrom ? last : curr,
            {}
          );
      }
    },
    currentMeter() {
      var that = this;
      if (this.meters) {
        var currentMeters = this.$_.filter(this.meters, function(meter) {
          return !that.$_.has(meter, 'Removed');
        });
        if (currentMeters.length > 1) {
          currentMeters.forEach((meter) => {
            meter.MeterConfigs.forEach((config) => {
              if (config.MeterStatus == 'Live') {
                currentMeters = [meter];
              }
            });
          });
        }
        return currentMeters[0];
      }
    },
    currentAQ() {
      if (this.activeServiceType === 'Gas') {
        return this.$_.sortBy(
          this.meterPoint.AnnualisedQuantity,
          'EffectiveFrom'
        ).reverse()[0].Aq;
      }
      return null;
    },
    mapsQuery() {
      // return this.$store.getters.mapsQuery;
      let components = '';
      if (this.activeServiceType === 'Gas')
        components = this.activeService.Site.Address.Postcode.split(' ');
      else if (this.activeServiceType === 'Electricity')
        components = this.activeService.MeterPoint.PostCode.split(' ');

      if (components) {
        return components[0] + '+' + components[1];
      }
    },
    contractsByServiceIdentifier() {
      return this.$store.state.meters.contractsByServiceIdentifier;
    },
    shouldShowAdvances() {
      // Use definitive logic: customer has ever been HH AND advance ranges are available
      const hasEverBeenHH = this.$store.getters.hasEverBeenHH;
      const advanceRangesAvailable = this.$store.state.meters.advanceRangesAvailable;
      
      return hasEverBeenHH && advanceRangesAvailable === true;
    },
    HhMeterPoint() {
      // Return mock HhMeterPoint if advance ranges are available
      // This maintains component compatibility while using authoritative advance range data
      return this.shouldShowAdvances 
        ? { /* Mock object for component compatibility */ }
        : null;
    },
    googleApi() {
      return this.$config.honeycomb.googleApi;
    },

    activeServiceTenancySharedId() {
      return this.activeService.Service[`${this.activeServiceType}Details`]
        .TenancySharedId;
    },

    tenancy() {
      if (this.tenancies)
        return this.tenancies.find(
          (t) => t.TenancySharedId === this.activeServiceTenancySharedId
        );
    },

    tenancyAcquisitionType() {
      if (this.tenancy) return this.tenancy.AcquisitionType;
    },

    tenancyReleaseType() {
      if (this.tenancy) return this.tenancy.ReleaseType;
    },

    tennancyGains() {
      if (this.tenancies)
        return this.tenancies.filter(
          (t) => t.AcquisitionType === 'Transferred'
        );
    },
    tennancyLosses() {
      if (this.tenancies)
        return this.tenancies.filter((t) => t.ReleaseType === 'Transferred');
    },

    prevTenancy() {
      if (this.tenancyAcquisitionType !== 'Transferred') return;
      if (this.tennancyLosses)
        return this.tennancyLosses.find((t) =>
          moment(t.EffectiveTo).isSame(this.tenancy.EffectiveFrom, 'day')
        );
    },

    nextTenancy() {
      if (this.tenancyAcquisitionType === 'NotReleased') return;
      if (this.tennancyGains)
        return this.tennancyGains.find((t) =>
          moment(t.EffectiveFrom).isSame(this.tenancy.EffectiveTo, 'day')
        );
    },
  },
  methods: {
    showPanel() {
      this.$showPanel({
        component: ReadingsPanel,
        openOn: 'right',
        cssClass: 'add-meter-reading-panel',
        props: {
          //any data you want passed to your component
        },
      });
    },
    transferredCustomer(direction) {
      switch (direction) {
        case 'to':
          return this.nextTenancy;
        case 'from':
          return this.prevTenancy;
      }
    },
    cloneSite() {
      this.$store.commit('cloneSiteAddress', this.activeService.Site.Address);
    },
    onCopy(e, elementId) {
      this.$snotify.success(`${e.text} copied to clipboard.`);
      document.getElementById(elementId).click();
    },
    onError() {
      this.$snotify.error(`Failed to copy text to clipboard.`, {
        timeout: 0,
        closeOnClick: true,
      });
    },

    promptDoNotBill(DoNotBill) {
      // Stash the desired state and prompt for a mandatory reason; nothing is persisted
      // until the operator saves the reason.
      this.pendingDoNotBill = DoNotBill;
      this.$bvModal.show(this.reasonModalId);
    },

    onReasonSave(reason) {
      const DoNotBill = this.pendingDoNotBill;
      this.pendingDoNotBill = null;
      if (DoNotBill === null) return;
      this.setDoNotBill(DoNotBill, reason);
    },

    onReasonCancel() {
      // Cancel leaves the Bill Service status unchanged and sends nothing.
      this.pendingDoNotBill = null;
    },

    setDoNotBill(DoNotBill, reason) {
      this.$http
        .put(
          `https://${
            this.$config.honeycomb.contractbot.domain
          }/api/v1/tenancies/${this.tenancy.TenancySharedId}`,

          {
            SharedId: this.tenancy.TenancySharedId,
            CustomerId: this.tenancy.CustomerId,
            DoNotBill,
            Reason: reason,
          },
          {
            withCredentials: true,
          }
        )
        .then(({ data: tenancy }) => {
          this.$store.commit('updateTenancy', tenancy);
        });
    },

    openHistory() {
      this.$bvModal.show(this.historyModalId);
      this.fetchHistory();
    },

    fetchHistory() {
      this.historyError = false;
      this.historyLoading = true;
      this.$http
        .get(
          `https://${
            this.$config.honeycomb.contractbot.domain
          }/api/v1/tenancies/${this.tenancy.TenancySharedId}/audit`,
          {
            params: { customerId: this.tenancy.CustomerId },
            withCredentials: true,
          }
        )
        .then(({ data }) => {
          this.historyChanges = data || [];
        })
        .catch(() => {
          this.historyError = true;
        })
        .finally(() => {
          this.historyLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.bill-service-history {
  color: #2f6fed;
  text-decoration: none;
  cursor: pointer;
}
.bill-service-history:hover {
  text-decoration: underline;
}
.bill-service-toggle {
  display: inline-block;
  margin-top: 12px;
}
</style>
